import { CatalogHeader } from './catalog-header'
import { catalogThemeVars } from '../lib/catalog-utils'
import { Outlet } from 'react-router-dom'
import { useEffect } from 'react'

export function CatalogPage() {
  useEffect(() => {
    document.body.classList.add('noise-disabled')
    return () => {
      document.body.classList.remove('noise-disabled')
    }
  }, [])

  return (
    <section className="py-10" style={catalogThemeVars}>
      <CatalogHeader />
      <Outlet />
    </section>
  )
}
